export enum XpressVehicleStatus {
    New = 1,
    Pending = 2,
    Approved = 3,
    Rejected = 4,
    Training = 5,
    Activation = 6,
    CheckingVehicleDetails = 7,
    CheckingOrCr = 8,
    CheckingSpaAl = 9,
    CheckingPaCpcTas = 10,
    CheckingPami = 11,
    CheckingCI = 12
}
